import { Quote } from "lucide-react";
import { SectionHead, FadeIn } from "./Shared";

// SAMPLE QUOTES — replace with real client testimonials when ready.
const TESTIMONIALS = [
  {
    quote: "The roller came out better than the car looked in person. Cinematic from the first frame.",
    name: "Frank",
    role: "Car Owner, GTA",
  },
  {
    quote: "Our banquet recap felt like a movie trailer. Guests keep asking who filmed it.",
    name: "Mustafa",
    role: "Event Host, Toronto",
  },
  {
    quote: "Quick, professional, and the shots sold the build within a week of posting.",
    name: "Kevin",
    role: "Realtor",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-16 md:py-24 border-t border-white/10" data-testid="testimonials-section">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <SectionHead index="05" kicker="Testimonials" title="Word on" accent="the Street" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <FadeIn key={t.name} delay={i * 0.07}>
              <figure className="h-full flex flex-col justify-between border border-white/10 bg-surface/40 p-8 hover:border-gold/40 transition-colors duration-300" data-testid={`testimonial-card-${i}`}>
                <div>
                  <Quote size={22} className="text-gold mb-6" fill="currentColor" />
                  <blockquote className="font-serifaccent italic text-lg md:text-xl text-zinc-200 leading-snug">
                    “{t.quote}”
                  </blockquote>
                </div>
                <figcaption className="mt-8 pt-6 border-t border-white/10">
                  <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-gold">{t.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">{t.role}</p>
                </figcaption>
              </figure>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
